import React, { useState } from "react";
import axios from "axios";
import { generateConfig } from "../../utils/api";
import { useSelector } from "react-redux";

function UploadSchedule() {
    const [file, setFile] = useState(null);
    const token = useSelector((state) => (state.auth.token));
    const { baseURL } = generateConfig();

    const onFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const onUpload = async () => {
        const formData = new FormData();
        formData.append("csv", file);

        try {
            const response = await axios.post(
                `${baseURL}/api/schedule/upload`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "x-api-token": process.env.REACT_APP_TOKEN,
                        "x-api-secret": process.env.REACT_APP_SECRET,
                        "x-user-token": token,
                    },
                }
            );
            console.log(response.data);
            alert('File upload completed successfully!');
        } catch (err) {
            console.error("Error uploading file:", err);
        }
    };

    return (
        <div className="container mx-auto mt-5">
            <h2 className="text-2xl font-semibold mb-4">
                Upload Daily Schedule CSV
            </h2>
            <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                    CSV File
                </label>
                <input
                    type="file"
                    className="mt-1 p-2 border rounded-sm"
                    onChange={onFileChange}
                />
            </div>
            <button
                className="px-4 py-2 bg-blue-500 text-white font-semibold rounded-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-opacity-50"
                onClick={onUpload}
            >
                Upload
            </button>
        </div>
    );
}

export default UploadSchedule;
